/** One cart owner publishes state, including for header components mounted later. */
type HeaderState = { visible: boolean; count: number; open: boolean };
const initial: HeaderState = { visible: false, count: 0, open: false };
let snapshot = initial;
const listeners = new Set<() => void>();
export const getHeaderState = () => snapshot;
export const getServerHeaderState = () => initial;
export function subscribeHeaderState(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function publishHeaderState(next: HeaderState) {
  if (next.visible === snapshot.visible && next.count === snapshot.count && next.open === snapshot.open) return;
  snapshot = next;
  for (const listener of listeners) listener();
}
export function resetHeaderState() { publishHeaderState(initial); }
